import React from 'react';
import { getConfig } from "@root/config/config";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { authSlice } from "@common/redux/slices/auth.slice";
import { AuthModal } from "@kursk/components/Layout/AuthModal/AuthModal";
import {
  ENABLED_FAVORITES_ENTITY_TYPES,
  FAVORITES_ENTITY_TYPES,
  FavoritesTypesEnum
} from "@common/redux/types/favorites";
import {
  addToFavorite,
  checkIsFavoriteItem,
  favoritesSlice,
  removeFromFavorite
} from "@common/redux/slices/favorites/favorites.slice";
import { notificationPush } from "@common/redux/slices/notification.slice";
import { useDispatch } from "react-redux";
import { useDispatchThunk } from "@common/redux/dispatchThunk";
import { FavoritesButton } from "@kursk/components/ui/FavoritesButton/components/FavoritesButton/FavoritesButton";
import { TPublicFavoritesButtonProps } from "./types/types";

const config = getConfig();

const isAvailableForCurrentRegion = config.features.favorites.enabled;

export const PublicFavoritesButton = ({
  entity,
  entityId,
  entityType,
}: TPublicFavoritesButtonProps) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isOpenAuthModal, setIsOpenAuthModal] = React.useState(false);
  const dispatch = useDispatch();
  const dispatchThunk = useDispatchThunk();
  const { user } = useSelectSlice(authSlice);
  const { isFavorite } = useSelectSlice(favoritesSlice);

  const checkIsFeatureEnabled = () => {
    /** Проверяем, что фича включена на регионе и кнопка должна отображаться в текущем разделе entityType **/
    if (isAvailableForCurrentRegion && ENABLED_FAVORITES_ENTITY_TYPES.includes(entityType)) {
      /** Проверка, что сущность обзора открыта в разделе для Обзоров
       * и у нее правильная категория, чтобы отобразить кнопку избранное **/
      if (entityType === FavoritesTypesEnum.Overviews) {
        return entity?.category?.sysName === 'obzor';
      }
      return true;
    } else {
      return false;
    }
  }

  const isFeatureEnabled = checkIsFeatureEnabled();

  const checkIsFavorite = () => {
    dispatchThunk(checkIsFavoriteItem({ entityId, entityType: FAVORITES_ENTITY_TYPES[entityType] }) as any);
  }

  React.useEffect(() => {
    if (user && isFeatureEnabled && entityId) {
      checkIsFavorite();
    }
  }, [entityId, user, isFeatureEnabled]);

  const onAddToFavorite = async () => {
    setIsLoading(true);

    if (!isFavorite) {
      const res =
        await dispatchThunk(addToFavorite({ entityId, entityType: FAVORITES_ENTITY_TYPES[entityType] }) as any);
      if (!res.error) {
        dispatch(notificationPush({ content: 'Добавлено в избранное', type: 'success' }));
        checkIsFavorite();
      }
    } else {
      const res =
        await dispatchThunk(removeFromFavorite({ entityId, entityType: FAVORITES_ENTITY_TYPES[entityType] }) as any)
      if (!res.error) {
        dispatch(notificationPush({ content: 'Удалено из избранного', type: 'success' }));
        checkIsFavorite();
      }
    }

    setIsLoading(false);
  }

  const openModal = () => {
    if (user) {
      onAddToFavorite();
    } else {
      setIsOpenAuthModal(true);
    }
  };


  return isFeatureEnabled ? (
    <>
      <AuthModal isOpen={isOpenAuthModal} setIsOpen={setIsOpenAuthModal}/>
      <FavoritesButton isFavorite={isFavorite} isLoading={isLoading} onClick={openModal} />
    </>
  ) : null;
};
